import { render, staticRenderFns } from "./r-smart-offer-bundle-magic-spin.vue?vue&type=template&id=a39dbd8e"
import script from "./r-smart-offer-bundle-magic-spin.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-magic-spin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a39dbd8e')) {
      api.createRecord('a39dbd8e', component.options)
    } else {
      api.reload('a39dbd8e', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-magic-spin.vue?vue&type=template&id=a39dbd8e", function () {
      api.rerender('a39dbd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-magic-spin/r-smart-offer-bundle-magic-spin.vue"
export default component.exports